/* Movatic WMS — Frontend | CesarFilho 932048016 */
import CrudList from '@/components/CrudList'

export default function RejectionReasons() {
  return (
    <CrudList
      title="Motivos de indisponibilidade"
      endpoint="/api/workforce/rejection-reasons/"
      writable
      columns={[
        { key: 'code', header: 'Código' },
        { key: 'name', header: 'Nome' },
        { key: 'behavior', header: 'Comportamento' },
        { key: 'duration_seconds', header: 'Duração (s)' },
        { key: 'is_active', header: 'Ativo' },
      ]}
    />
  )
}
